import Utils from "../../services/Utils.js";
import {} from "../../js/api/countries.js";
import {getCountries} from "../../js/api/countries.js";
import {getFeaturedMatches} from "../../js/api/featuredPreMatch.js";
import { _t } from "../../services/TranslationService.js";

let Categories = {
    render : async () => {
        let request = Utils.parseRequestURL();
        let countries = await getCountries(request.id);
        let countryView = '';
        let featuredPrematchView = '';
        let featuredPrematchs = await getFeaturedMatches(request.id);
        let sportName = countries[0].sport
        let sportId = countries[0].sport_id
        countries.forEach(country => {
            // <a href="#/p/${post.id}">${post.title}</a>
            countryView = countryView + `<a class="countryListContentItem" href="#/league/${country.id}" data-id="${country.id}">${country.name}</a>`;
        });

        if (request.id == 1) {
            featuredPrematchs.forEach((featuredPrematch) => {
                const date = new Date(featuredPrematch.game_date);
                let dd = String(date.getDate()).padStart(2, '0');
                let mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
                let yyyy = date.getFullYear();
    
                const time = `${featuredPrematch.game_time.split(":")[0]}:${featuredPrematch.game_time.split(":")[1]}`
                if( featuredPrematch.odd){
                    featuredPrematchView = featuredPrematchView + `<div class="featuredPrematchItem">
                   <a href="#/Match/${featuredPrematch.id}" class="featuredMatchName">
                       <span>${featuredPrematch.home_team}</span>
                       <span>${featuredPrematch.away_team}</span>
                    </a>
                    <span class="featurePreMatchDate">${dd}/${mm} ${time}</span>
                        <span class="numberofmarkets">${featuredPrematch.count_options} ></span>
                    <div class="featuredMatchBtn">
                        <div class="singleHomeOdd bettingBtn ${ Math.floor(( parseFloat(featuredPrematch.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100  == 1 ? 'disabledBtn' : '' } ${featuredPrematch.odd.split(',')[0].split('|')[0]}" match-odd="${featuredPrematch.odd.split(',')[0].split('|')[1]}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(',')[0].split('|')[2]) ? "Rezultat final" : featuredPrematch.odd.split(',')[0].split('|')[2]}" match-market-option="1 " coef-id="${featuredPrematch.odd.split(',')[0].split('|')[0]}" bet-id="${(featuredPrematch.odd.split(',')[0].split('|')[0])}" game-id="${featuredPrematch.id}"><i>1</i><i>${(Math.floor((  parseFloat(featuredPrematch.odd.split(',')[0].split('|')[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                         <div class="singleDrawOdd bettingBtn ${Math.floor((parseFloat( featuredPrematch.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100  == 1 ? 'disabledBtn' : '' } ${featuredPrematch.odd.split(',')[1].split('|')[0]}" match-odd="${featuredPrematch.odd.split(',')[1].split('|')[1]}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(',')[1].split('|')[2]) ? "Rezultat final" : featuredPrematch.odd.split(',')[1].split('|')[2]}" match-market-option="X " coef-id="${featuredPrematch.odd.split(',')[1].split('|')[0]}" bet-id="${(featuredPrematch.odd.split(',')[1].split('|')[0])}" game-id="${featuredPrematch.id}"><i>X</i><i>${(Math.floor(( parseFloat(featuredPrematch.odd.split(',')[1].split('|')[1]) + Number.EPSILON) * 100) / 100 ).toFixed(2)}</i></div>
                         <div class="singleAwayOdd bettingBtn ${Math.floor((parseFloat( featuredPrematch.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100  == 1 ? 'disabledBtn' : '' } ${featuredPrematch.odd.split(',')[2].split('|')[0]}" match-odd="${featuredPrematch.odd.split(',')[2].split('|')[1]}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(',')[2].split('|')[2]) ? "Rezultat final" : featuredPrematch.odd.split(',')[2].split('|')[2]}" match-market-option="2 " coef-id="${featuredPrematch.odd.split(',')[2].split('|')[0]}" bet-id="${(featuredPrematch.odd.split(',')[2].split('|')[0])}" game-id="${featuredPrematch.id}"><i>2</i><i>${(Math.floor(( parseFloat(featuredPrematch.odd.split(',')[2].split('|')[1]) + Number.EPSILON) * 100) / 100 ).toFixed(2)}</i></div>
                    </div>
              </div>`
                }
            });
        }
        



        // let posts = await getPostsList()
        let view =  /*html*/`

            <div class="pageHeaderTitle">
                <a class="backBtn">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                </a>
                <span>${sportName}</span>
                <a href="#/InPlay/${sportId}" class="liveTitleBtn">${_t('Live <i>InPlay</i>')}</a>
            </div>
            ${request.id == 1 ?` <div class="betModule liveInModule accordionDisable">
            <div class="betModuleHeaderContainer"> 
              <a class="betModuleHeaderBtn">
                <span>${_t('Ndeshjet Kryesore')}</span>
                <span class="yellowColored"></span>
              </a>
              <a class="betHeaderEventBtn" href="#/inPlay">
                
              </a>
            </div>
       </div>
       <div class="featuredPrematchWrapper">
           <div class="featuredPrematchSlider">
               ${featuredPrematchView}
           </div>            
       </div>` :""}
           
            <div class="countryHeaderLabel m-t-6">
             <span>${_t('Countries')}</span>
            </div>
            <div class="countryHeaderContent">
             ${countryView}
            </div>
         
       `
        return view
    }
    , after_render: async () => {

        $('body .featuredPrematchWrapper').each(function(){
            let featuredSliderWidth = 0;
            $(this).children('.featuredPrematchSlider').children('.featuredPrematchItem').each(function(){
                featuredSliderWidth += $(this).outerWidth() + 3;
                console.log('asdasd')
            });

            $(this).children('.featuredPrematchSlider').css({
                'width': featuredSliderWidth - 3 + 'px'
            });
        });
    }

}

export default Categories;
